import React from "react";
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from "react-router";
import { Sentry, SentryAdapter } from "./index";
import type { LogContext } from "./logger.context";
import type { Environment } from "./index";

interface SentryConfig {
  dsn: string;
  environment: Environment;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
  context: LogContext;
}

export class SentryLogger extends SentryAdapter {
  constructor(options: SentryConfig) {
    super();
    if (!options.dsn) return;

    Sentry.setUser({
      username: options.context.user?.username ?? undefined,
      email: options.context.user?.email ?? undefined,
    });

    Sentry.init({
      dsn: options.dsn,
      environment: options.environment,
      sendDefaultPii: true,
      enableLogs: true,
      replaysSessionSampleRate: options.replaysSessionSampleRate,
      replaysOnErrorSampleRate: options.replaysOnErrorSampleRate,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          maskAllInputs: false,
        }),
        Sentry.reactRouterBrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
    });
  }
}
